import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { ToastHost } from '@/shared/components/ui/ToastHost'
import type { RouterContext } from '@/types/router'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
})

function RootLayout() {
  return (
    <>
      <Outlet />
      <ToastHost />
    </>
  )
}
